import { makeStyles, tokens } from '@fluentui/react-components';
import { useMsal } from '@azure/msal-react';
import { brand } from '@/shared/styles/colors';
import { devAuthEnabled } from '@/config/devAuth';
import { useCurrentUser } from '@/shared/hooks/useCurrentUser';
import { AppButton } from '@/shared/components/ui';
import { BrandLockup } from './BrandLockup';

const useStyles = makeStyles({
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 200,
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
    height: brand.navHeight,
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: brand.maxContentWidth,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
    height: '100%',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
});

export function Header() {
  const styles = useStyles();
  const { accounts, instance } = useMsal();
  const user = useCurrentUser();

  // Mirror HomePage's auth check: dev-auth uses the simulated role; production
  // uses the MSAL account list. The sign-in button is a production-only affordance.
  const isAuthenticated =
    devAuthEnabled ? user !== null && user.role !== null : accounts.length > 0;
  const showSignIn = !devAuthEnabled && !isAuthenticated;

  const handleLogin = () => {
    void instance.loginRedirect({ scopes: [] });
  };

  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <BrandLockup subtitle="External AI Product Intake" />
        {showSignIn && (
          <div className={styles.actions}>
            <AppButton variant="primary" size="small" onClick={handleLogin}>
              Sign In
            </AppButton>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
